export const externalUrl = {
  utex: 'https://utex.io',
  utexPartners: 'https://partners.utex.io',
  utexStocks: 'https://utex.io/stocks',
  utexAurora: 'https://utex.io/aurora'
};



// WEBPACK FOOTER //
// ./src/consts/urls.js